import styled, { css } from "styled-components";
import { outlineBorderActiveBlueCSS, outlineBorderActiveRedCSS, outlineBorderCSS, } from "../../common/outlineActive";
import { cssBody100, cssBody200, cssBody400 } from "../typography/styles";
export const defaultControlFontCSS = cssBody400;
export const defaultControlSize = "100";
export const controlSizeThemes = {
    "50": css `
    min-height: 24px;
  `,
    "100": css `
    min-height: 32px;
  `,
    "200": css `
    min-height: 40px;
  `,
    "400": css `
    min-height: 56px;
  `,
};
export const controlFontThemes = {
    "50": cssBody200,
    "100": cssBody400,
    "200": cssBody400,
    "400": cssBody400,
};
export const scrollStylesCSS = css `
  @supports (-moz-appearance: none) {
    scrollbar-color: ${({ theme }) => `${theme.systemColors.grey400} "transparent"`};
    scrollbar-width: thin;
  }

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    &:not(.non-scroll-styles)::-webkit-scrollbar {
      width: 14px;
      height: 14px;
    }

    &:not(.non-scroll-styles)::-webkit-scrollbar-track {
      background: transparent;
      width: 100%;
    }

    &:not(.non-scroll-styles)::-webkit-scrollbar-thumb {
      border: ${(p) => p.theme.spacing.sp4} solid transparent;
      background-clip: padding-box;
      box-sizing: border-box;
      border-radius: 100px;
      background-color: rgba(103, 132, 162, 0.6);
      min-height: 50px;
    }

    &:not(.non-scroll-styles)::-webkit-scrollbar-thumb:hover {
      background-color: ${(p) => p.theme.systemColors.grey400};
    }

    &:not(.non-scroll-styles)::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
`;
export const newControlWrapperCSS = css `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;

  ${(p) => controlSizeThemes[p.$size || defaultControlSize]};
  ${(p) => controlFontThemes[p.$size || defaultControlSize]};
  color: ${(p) => p.theme.systemColors.grey800};

  border-radius: 6px;
  background-color: #fff;
  border: 1px solid ${(p) => p.theme.systemColors.grey400};

  ${outlineBorderCSS};
  transition:
    box-shadow 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    outline-color 0.2s ease;

  ${(p) => !p.$disabled &&
    !p.$edited &&
    css `
      &:hover {
        border-color: ${(p) => p.theme.systemColors.grey600};
      }
    `}
  ${(p) => p.$active &&
    css `
      ${outlineBorderActiveBlueCSS};

      &:hover {
        border-color: ${({ theme }) => theme.systemColors.blue600};
      }
    `}
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  ${({ $disabled, theme }) => $disabled
    ? css `
          background: ${theme.systemColors.grey200};
          border-color: ${theme.systemColors.grey200};
          box-shadow: none;
        `
    : css `
          &:focus,
          &:focus-within {
            ${outlineBorderActiveBlueCSS};
          }
        `}
  input, select, textarea {
    color: ${(p) => p.theme.systemColors.grey800};

    &::placeholder {
      color: ${(p) => p.theme.systemColors.grey300};
    }

    ${scrollStylesCSS};
  }

  ${({ $invalid, theme }) => $invalid &&
    css `
      background-color: ${theme.systemColors.red100};
      border-color: ${theme.systemColors.red400};

      &:hover {
        border-color: ${theme.systemColors.red400};
      }

      &:focus,
      &:focus-within {
        border-color: ${(p) => p.theme.systemColors.red400};
        ${outlineBorderActiveRedCSS};
      }

      input,
      select {
        ::placeholder {
          color: ${theme.systemColors.red400};
        }
      }
    `}

  ${(p) => p.$edited &&
    css `
      background-color: ${p.theme.systemColors.blue50};
      border-color: ${p.theme.systemColors.blue600};
    `}

  ${(p) => p.$locked &&
    css `
      border-color: ${p.theme.systemColors.grey200};

      &:hover {
        border-color: ${p.theme.systemColors.grey200};
      }
    `}
`;
export const NewControlWrapper = styled.div `
  ${newControlWrapperCSS};
`;
export const nakedInputCSS = css `
  border: none;
  background: none;
  height: 100%;
  width: 100%;
  display: block;
  appearance: none;
  padding: 0;
  outline: none;
  font: inherit;
  min-width: 2px;
  color: currentColor;
  caret-color: currentColor;

  ::placeholder {
    font: inherit;
  }
`;
export const NakedInput = styled.input `
  ${nakedInputCSS};

  ${({ isClickable }) => isClickable &&
    css `
      cursor: pointer;
    `}

  ${({ disabled, isClickable }) => disabled &&
    !isClickable &&
    css `
      cursor: not-allowed;
    `}
`;
export const NakedTextArea = styled.textarea `
  ${nakedInputCSS};
`;
export const InputErrorMessage = styled.p `
  ${cssBody100};
  color: ${(p) => p.theme.systemColors.red400};
  margin: ${(p) => p.theme.spacing.sp8} 0 0;
  padding: 0;
`;
